import styled from "styled-components";
import Botao from "../../componentes/Botao";
import ErroSpan from "../../componentes/ErroSpan";
import { DivTickets, InputsTickets, LabelsTickets, LadoALado } from "./TicketsStyled";
import { cancelarIngresso, getTicket } from "../../servicos/ticketsServices";

const ContainerModal = styled.div`
    display: ${props => props.$mostrar? "block" : "none"};
    position: fixed;
    overflow: auto;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 3000px;
    background-color: #000000ab;
    z-index: 99;
`
const DivModal = styled.div`
    display: "block";
    font-size: ${props => props.$tamFonte || "30px"};
    height: ${props => props.$altura || "300px"};
    width: ${props => props.$largura || "400px"};
    margin-left: ${props => props.$largura? - Math.floor(Number(props.$largura.slice(0, -2)))/2+"px" : "-200px"};
    background-color: #e4e4e4;
    position: relative;
    top: 40%;
    left: 50%;
    margin-top: -150px;
    overflow: auto;
    border-radius: 5px;
    outline: 1px solid black;

    p {
        margin: 0 0 0 20px;
        padding: 0;
        margin-top: 5px;
    }
    button {
        background-color: var(--corNugaliEscura);
        color: var(--corNugaliClara);
        padding: 5px 10px;
        margin: 10px auto;
    }
`
const DadosIngresso = styled.div`
    margin-left: 50px;
`
const LinhaDados = styled.div`
    display: flex;
    color: #252525;
    font-size: 18px;
`
const DivBotoes = styled.div`
    position: absolute;
    bottom: 10px;
    right: 20px;
    width: auto;
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-end;
    margin: 0;
    align-items: center;
    button {
        margin-right: 10px;
        margin-top: 10px;
    }
`

export function ModalCancelamento(showModal, setShowModal, ingressoCancelar, setIngressoCancelar, ingressoIn, setIngressoIn, motivoCancelamento, setMotivoCancelamento, cancelamento, setCancelamento, carregando, setCarregando){
    
    async function cancelarTicket() {
        if (!motivoCancelamento) return setCancelamento({
            mostrar: true,
            erro: true,
            mensagem: "Informe um motivo"
        });
        if (ingressoCancelar.foto) return setCancelamento({
            mostrar: true,
            erro: true,
            mensagem: "Esse ingresso foi utilizado e não pode ser cancelado"
        });
        const resposta = await cancelarIngresso(ingressoCancelar.numero, motivoCancelamento);
        if (resposta.status === 200) {
            setCancelamento({
                mostrar: true,
                erro: false,
                mensagem: resposta.mensagem
            });
            setMotivoCancelamento("");
            setIngressoIn("");
            setIngressoCancelar(null);
        } else {
            setCancelamento({
                mostrar: true,
                erro: true,
                mensagem: resposta.mensagem
            });
        }
    }
    async function obterIngresso(){
        if (!ingressoIn) return;
        setCarregando(true);
        setCancelamento({
            mostrar: false,
            erro: false,
            mensagem: ""
        });
        const resposta = await getTicket(ingressoIn);
        if (resposta && resposta.status === 200) {
            if (resposta.totalDocs === 0) setCancelamento({
                mostrar: true,
                erro: true,
                mensagem: "Ingresso inexistente ou já cancelado!"
            }); else {
                setIngressoCancelar(resposta.tickets[0]);

                if (resposta.tickets[0] && resposta.tickets[0].foto) setCancelamento({
                    mostrar: true,
                    erro: true,
                    mensagem: "Este ingresso já foi utilizado!"
                });
            }
        }
        setCarregando(false);
    }
    function fecharCancelamento() {
        setShowModal(false);
        setIngressoIn("");
        setIngressoCancelar(null);
        setCancelamento({
            mostrar: false,
            erro: false,
            mensagem: ""
        });
    }

    return (<ContainerModal $mostrar={showModal}>
        <DivModal $altura={"500px"} $largura={"600px"}>
            <form onSubmit={ event => {
                event.preventDefault();
                obterIngresso();
            }}>
            <LadoALado>
                <DivTickets $largura="430px" $margem="10px 10px 10px 50px">
                    <LabelsTickets>Informe ou leia o ingresso</LabelsTickets>
                    <InputsTickets value={ingressoIn} onChange={e => setIngressoIn(e.target.value)}/>
                </DivTickets>
                <Botao style={{marginTop: "50px", marginLeft: "10px"}} type="submit">Ok</Botao>
            </LadoALado>
            </form>
            {ingressoCancelar && <DadosIngresso>
                <LinhaDados><p style={{width: "100px"}}>Número</p>{ingressoCancelar.numero}</LinhaDados>
                <LinhaDados><p style={{width: "100px"}}>Sessão:</p>{ingressoCancelar.sessao.diaHora.split("T")[0].split("-")[2]}/{ingressoCancelar.sessao.diaHora.split("T")[0].split("-")[1]}/{ingressoCancelar.sessao.diaHora.split("T")[0].split("-")[0]} - {ingressoCancelar.sessao.diaHora.split("T")[1].slice(0,5)}</LinhaDados>
                <LinhaDados><p style={{width: "100px"}}>Tipo:</p>{ingressoCancelar.tipo}</LinhaDados>
                <LinhaDados><p style={{width: "100px"}}>Visitante:</p> {ingressoCancelar.visitante.nome || ingressoCancelar.visitante.email || ingressoCancelar.visitante.celular || ingressoCancelar.visitante._id}</LinhaDados>
                <DivTickets $largura="500px" $margem="10px 10px 10px 0px">
                    <LabelsTickets>Motivo do cancelamento</LabelsTickets>
                    <InputsTickets value={motivoCancelamento} onChange={ e => setMotivoCancelamento(e.target.value)}/>
                </DivTickets>
            </DadosIngresso>}
            {ingressoCancelar && ingressoCancelar.cancelado && <ErroSpan $corFundo="#ffcdcd">Ingresso já cancelado!</ErroSpan>}
            {cancelamento.mostrar && <ErroSpan $corFundo={cancelamento.erro? "#ffcdcd": "#ddffcd"} $corTexto={cancelamento.erro? "#9e0000": "#209e00"}>{cancelamento.mensagem}</ErroSpan>}
            <DivBotoes>
                <Botao disabled={ingressoCancelar?.numero? false: true || carregando} onClick={() => cancelarTicket()}>Confirmar</Botao>
                <Botao onClick={() => fecharCancelamento()}>Fechar</Botao>
            </DivBotoes>
        </DivModal>
    </ContainerModal>)
}